import Home from './main/home';
import PublicInformation from './main/myAccount/publicInformation';
import PrivateInformation from './main/myAccount/privateInformation';
import WebsiteName from './main/myAccount/myWebsite';
import OrderHistory from './main/orders/order';
import Membership from './main/myAccount/membership';
import iWallet from './main/iWallet/iWallet';
import PlacementPreference from './main/myTeam/placementPreference';
import DualTeamPlacementTree from './main/myTeam/binaryPlacementTree';
import SponsorTree from './main/myTeam/sponsorTree';
import BecomeanAffiliate from './main/becomeAnAffiliate';
import Leads from './main/projects/projectList';
import Calendar from './main/calendar/calendar';
import PersonallySponsored from './main/personallySponsored/personallySponsored';
import DualTeamBonus from './main/dualTeamBonusCommissions/dualTeamBonusCommission';
import DualTeamBonusVolume from './main/dualTeamBonusVolumes/dualTeamBonusVolume';
import MySponsor from './main/myTeam/sponsorInfo';
import Rewards from './main/rewards/rewards';
import AventiTravel from './main/travelVertex/travelVertex';
import RippleSecure from './main/rippleSecureSignup/rippleSecureSignup'
import AffiliateLeads from './main/affiliateProjects/affiliateProjectsList';
import Omni from './main/omni/omni';
import BNBWallet  from './main/publicWalletAddress/evmWallet';

const componentMap = {
  "/home": Home,
  "/publicInfo": PublicInformation,
  "/privateInfo": PrivateInformation,
  "/myWebsiteName": WebsiteName,
  "/order": OrderHistory,
  "/membership": Membership,
  "/iWallet": iWallet,
  "/placementPreference": PlacementPreference,
  "/binaryPlacementTree": DualTeamPlacementTree,
  "/sponsorTree": SponsorTree,
  "/becomeanaffiliate": BecomeanAffiliate,
  "/projects": Leads,
  "/calendar": Calendar,
  "/personallySponsored": PersonallySponsored,
  "/dualTeamBonusCommission": DualTeamBonus,
  "/dualTeamBonusVolume": DualTeamBonusVolume,
  "/sponsorInfo": MySponsor,
  "/rewards": Rewards,
  "/aventitravel": AventiTravel,
  "/affiliateProjects": AffiliateLeads,
  "/rippleSecureSignup": RippleSecure,
  "/omni": Omni,
  "/bnbWallet": BNBWallet,
  // The link you add here must match the link added in the Admin menu.
  // If both links are the same, the correct component will load.
};

export default componentMap;